/* @flow */

export const SIMULATE_BRAINDATES_FETCH = 'SIMULATE_BRAINDATES_FETCH';
export const SIMULATE_BRAINDATE_FETCH = 'SIMULATE_BRAINDATE_FETCH';

export const FETCH_BRAINDATES_REQUEST = 'FETCH_BRAINDATES_REQUEST';
export const FETCH_BRAINDATES_SUCCESS = 'FETCH_BRAINDATES_SUCCESS';
export const FETCH_BRAINDATES_FAILURE = 'FETCH_BRAINDATES_FAILURE';

export const FETCH_BRAINDATE_REQUEST = 'FETCH_BRAINDATE_REQUEST';
export const FETCH_BRAINDATE_SUCCESS = 'FETCH_BRAINDATE_SUCCESS';
export const FETCH_BRAINDATE_FAILURE = 'FETCH_BRAINDATE_FAILURE';

export const CREATE_BRAINDATE = 'CREATE_BRAINDATE';

export const DELETE_BRAINDATE_LOCALLY = 'DELETE_BRAINDATE_LOCALLY';

export const UPDATE_CONVERSATION_UNREAD_COUNT =
  'UPDATE_CONVERSATION_UNREAD_COUNT';
